import React from 'react'
import styled from 'styled-components'
import Card from '@taglivros/oef_componentes/build/components/card'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import AppInfo from '../../../components/AppInfo/AppInfo'
import AppIcon from '../../../assets/icons/app-icon.png'

import { TITULO_CARD_APP } from '../constantsHome'
import { IconText } from '../../../components/IconText/icontext'

import { ReactComponent as Award } from '../../../assets/icons/award.svg'
import { ReactComponent as BarChart } from '../../../assets/icons/bar-chart.svg'
import { ReactComponent as HeadPhones } from '../../../assets/icons/headphones.svg'
import { ReactComponent as MessageCircle } from '../../../assets/icons/message-circle.svg'
import { ReactComponent as Tag } from '../../../assets/icons/tag.svg'


const Titulo = styled.h2`
  margin: 0;
`
const Container = styled.div`
  padding: 0;
  .app-icon-title {
    display: flex;
    img {
      padding-right: 20px;
    }
    h2 {
      display: flex;
      align-items: center;
    }
    padding-bottom: 10px;
  }
  .card {
    padding: 30px;
    display: flex;
    flex-direction: column;
    @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
      padding: 20px;
    }
  }
`

const CardApp = () => {
  return (
    <Container>
      <Card
        className="card"
        largura="100%"
        margin="0"
        padding="0"
      >
        <div className="app-icon-title">
          <img
            alt="icon"
            src={ AppIcon }
          />

          <Titulo>{TITULO_CARD_APP}</Titulo>
        </div>

        <div>
          <IconText
            Icon={ Award }
            text="Avalie os livros que você está lendo"
          />

          <IconText
            Icon={ BarChart }
            text="Adicione o seu progresso de leitura"
          />

          <IconText
            Icon={ MessageCircle }
            text="Discuta com outros taggers sobre os livros"
          />

          <IconText
            Icon={ HeadPhones }
            text="Tenha acesso a todos os conteúdos extras como podcasts e playlists"
          />

          <IconText
            Icon={ Tag }
            text="Fique por dentro de promoções e novidades da TAG"
          />

          <AppInfo />
        </div>
      </Card>
    </Container>
  )
}

export default CardApp
